import { render } from "./UserProfileWirte.vue?vue&type=template&id=315f0266&scoped=true"
import script from "./UserProfileWirte.vue?vue&type=script&lang=js"
export * from "./UserProfileWirte.vue?vue&type=script&lang=js"

import "./UserProfileWirte.vue?vue&type=style&index=0&id=315f0266&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315f0266"]])

export default __exports__